import { Box, Chip, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { TruncatedTypography } from "lib/@components/truncated-typography"
import { formatTime } from "lib/format-time"
import { COLOR_FROM_CLASSIFICATION, ICON_FROM_CLASSIFICATION } from "library/SFG20/constants.mjs"

export function AuthoringAddedTaskTailoredValue({ item: key, tailored = {}, chipSx }) {
    let value = null

    if (key === "title") {
        value = (
            <TruncatedTypography variant="body2" color="tailoredValueColors.text.main" sx={{ fontWeight: "bold" }}>
                {tailored?.title}
            </TruncatedTypography>
        )
    }

    if (key === "frequency") {
        const label = toAddedFrequencyLabel(tailored?.frequency)
        if (label) {
            value = (
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="caption">Frequency</Typography>
                    <TruncatedTypography
                        variant="body2"
                        color="tailoredValueColors.text.main"
                        sx={{ fontWeight: "bold" }}
                    >
                        {label}
                    </TruncatedTypography>
                </Stack>
            )
        }
    }

    if (key === "minutes") {
        const label = toAddedMinutesLabel(tailored?.minutes)
        if (label) {
            value = (
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="caption">Duration</Typography>
                    <TruncatedTypography
                        variant="body2"
                        color="tailoredValueColors.text.main"
                        sx={{ fontWeight: "bold" }}
                    >
                        {label}
                    </TruncatedTypography>
                </Stack>
            )
        }
    }

    if (key === "skill") {
        const label = toAddedSkillLabel(tailored?.skill)
        if (label) {
            value = (
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="caption">Skill</Typography>
                    <TruncatedTypography
                        variant="body2"
                        color="tailoredValueColors.text.main"
                        sx={{ fontWeight: "bold" }}
                    >
                        {label}
                    </TruncatedTypography>
                </Stack>
            )
        }
    }

    if (key === "classification") {
        if (tailored?.classification) {
            value = (
                <Stack direction="row" spacing={1} alignItems="center" data-cy="tailored-value-criticality-chip">
                    <Typography variant="caption">Criticality</Typography>
                    <Iconify
                        sx={{ color: COLOR_FROM_CLASSIFICATION[tailored.classification] }}
                        icon={ICON_FROM_CLASSIFICATION[tailored.classification]}
                    />
                    <Typography variant="body2" color="tailoredValueColors.text.main" sx={{ fontWeight: "bold" }}>
                        {tailored.classification}
                    </Typography>
                </Stack>
            )
        }
    }

    if (!value) return null

    return (
        <Box sx={{ py: 0.1 }}>
            <Chip
                size="small"
                sx={{
                    textTransform: "capitalize",
                    bgcolor: "info.lighter",
                    color: "tailoredValueColors.text.main",
                    ...chipSx,
                }}
                color="info"
                label={value}
                data-cy="tailored-value-chip"
            />
        </Box>
    )
}

function toAddedFrequencyLabel(frequency) {
    return frequency?.label ?? null
}

function toAddedMinutesLabel(minutes) {
    if (minutes == null) return null
    return formatTime(minutes)
}

function toAddedSkillLabel(skill) {
    return skill?.Skilling ?? skill ?? null
}
